export {QueryError};

class QueryError extends Error {
    cause: string;
    statusCode: number;
    code?: string;

    constructor(message: string, cause: string, statusCode: number, code?: string) {
        super(message);
        this.name = 'QueryError';
        this.cause = cause;
        this.statusCode = statusCode;
        this.code = code;


        Object.setPrototypeOf(this, QueryError.prototype);

        // Ensure stack trace is captured correctly
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        } else {
            this.stack = new Error(message).stack;
        }
    }
}